import { useLocation, Link } from "react-router-dom";
import { useEffect } from "react";
import { ArrowRight } from "lucide-react";
import { Kicker, SmchsLayout } from "@/components/smchs/Shell";

const NotFound = () => {
  const location = useLocation();

  useEffect(() => {
    console.error(
      "404 Error: User attempted to access non-existent route:",
      location.pathname
    );
  }, [location.pathname]);

  return (
    <SmchsLayout>
      <section className="max-w-[1280px] mx-auto px-5 md:px-8 py-24 md:py-36">
        <Kicker label="Page not found" />
        <h1 className="mt-5 font-display font-[900] text-[2.5rem] sm:text-[3.5rem] md:text-[4.5rem] leading-[0.96] tracking-[-0.03em] text-[var(--ink)] max-w-[16ch]">
          Not on the{" "}
          <span className="font-serif italic font-normal text-[var(--primary)]">shelf</span>.
        </h1>
        <p className="mt-6 max-w-[52ch] text-[1rem] md:text-[1.1rem] leading-[1.55] text-[var(--ink-soft)]">
          Nothing lives at this address. It may have moved, or the link may be wrong.
        </p>
        <div className="mt-10 flex flex-wrap gap-3">
          <Link
            to="/catalog"
            className="inline-flex items-center gap-2 rounded-full bg-[var(--ink)] text-[var(--paper)] px-6 py-3 text-[15px] font-medium hover:opacity-90 transition-opacity"
          >
            Search the catalog <ArrowRight className="w-4 h-4" />
          </Link>
          <Link
            to="/"
            className="inline-flex items-center gap-2 rounded-full border border-[var(--border)] px-6 py-3 text-[15px] font-medium text-[var(--ink)] hover:bg-[var(--surface-2)] transition-colors"
          >
            Back to the home page
          </Link>
        </div>
      </section>
    </SmchsLayout>
  );
};

export default NotFound;
